var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1749547355847,
    className: "icon_svg__icon",
    viewBox: "-50 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 29820,
    width: 200,
    height: 200
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.24 910.61H210a59.46 59.46 0 0 1-59.39-59.39V268.51A59.45 59.45 0 0 1 210 209.12h99.88v70.73a24 24 0 0 0 48 0v-70.73H562.2v70.73a24 24 0 0 0 48 0v-70.73h99.89a59.45 59.45 0 0 1 59.39 59.39v196.57a24 24 0 0 0 48 0V268.51a107.51 107.51 0 0 0-107.39-107.39H610.2V89.39a24 24 0 1 0-48 0v71.73H357.86V89.39a24 24 0 1 0-48 0v71.73H210a107.51 107.51 0 0 0-107.41 107.39v582.71A107.51 107.51 0 0 0 210 958.61h269.24a24 24 0 0 0 0-48z",
    fill: "#2c2c2c",
    "p-id": 29821
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M683.68 425.32a24 24 0 0 0-24-24H260.39a24 24 0 0 0 0 48h399.29a24 24 0 0 0 24-24zM260.39 578.05a24 24 0 0 0 0 48h201a24 24 0 0 0 0-48zM712.6 785.82a24 24 0 0 0 24-24v-112.5a24 24 0 0 0-48 0v112.5a24 24 0 0 0 24 24z",
    fill: "#2c2c2c",
    "p-id": 29822
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M712.6 541c-115.15 0-208.82 93.68-208.82 208.82s93.67 208.79 208.82 208.79 208.81-93.68 208.81-208.82S827.74 541 712.6 541z m0 369.64c-88.68 0-160.82-72.15-160.82-160.82S623.92 589 712.6 589s160.81 72.14 160.81 160.82-72.14 160.79-160.81 160.79z",
    fill: "#2c2c2c",
    "p-id": 29823
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M712.6 807.93a31.28 31.28 0 1 0 31.27 31.28 31.28 31.28 0 0 0-31.27-31.28z",
    fill: "#2c2c2c",
    "p-id": 29824
  })));
};
export default SvgIcon;